import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import Switch from "react-switch"
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Collapse
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";

import * as Yup from "yup";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SaveButton from "components/buttons/save";
import RsLink from "components/buttons/rsLink";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import Swal from "sweetalert2";
import SafeField from "helpers/SafeField";

class ManageRole extends Component {
  constructor(props) {
    super(props)
    this.state = {
          modules: [],
          openAccordion: null,
    }
            this.toggleManageRole = this.toggleManageRole.bind(this);
            this.toggleEditRole = this.toggleEditRole.bind(this);
            this.toggleSetPermission = this.toggleSetPermission.bind(this);
            this.formikRef = React.createRef();
  }
   roleToggle() {
    this.setState(prevState => ({
      isAddNew: !prevState.isAddNew
    }));
  }
  toggleManageRole() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }

   permissionToggle() {
    this.setState(prevState => ({
      isPermission: !prevState.isPermission
    }));
  }
  toggleSetPermission() {
    this.setState({ role: "", isPermission: !this.state.isPermission });
    this.permissionToggle();
  }
 toggleSetPermission = arg => {
    const role = arg;

    this.setState({
      role: {
            id: role.id,
      }
    })
    this.fecthRoleModule(role.id)
    this.permissionToggle();
 }

toggle() {
    this.setState(prevState => ({
        isManage: !prevState.isManage
    }));
}
 toggleEditRole() {
    this.setState({ role: "", isEdit: false, isManage: !this.state.isManage});
    this.toggle();
  }
 toggleEditRole = arg => {
    const role = arg;

    this.setState({
      role: {
            id: role.id,
            userRoleId:role.userRoleId,
            userRoleTitle:role.userRoleTitle,
            agentId: role.agentId,
            isActive: role.isActive
      }
    })
    this.toggle();
 }
 componentDidMount() {
    this.fetchRoles();
 }
 handleSubmit = (value) => {
  const { userRoleTitle, agentId } = value;
  const payload = {
    userRoleTitle,
    agentId: parseInt(agentId),
    isActive: true,
  };

  const token = JSON.parse(localStorage.getItem("authUser"))?.resultData?.bearerToken;
  if (!token) {
    toast.error("Unauthorized: No token found");
    return;
  }

  toast.loading("Please wait...");

  axios.post(`${API_URL}UserRole`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })
  .then(({ data }) => {
    toast.dismiss();

    if (data.success) {
      toast.success("Saved successfully!");
      this.fetchRoles();
      this.toggleManageRole();
    } else {
      toast.error(data?.validationErrors?.[0] || "Submission failed");
      console.warn("Submission failed:", data);
    }
  })
  .catch((error) => {
    toast.dismiss();
    console.error("Error submitting document:", error);
    toast.error("Something went wrong!");
  });
};

    fetchRoles() {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
  
      const params = {
        agentId: localStorage.getItem('userId')
      };
      axios
        .get(`${API_URL}UserRole/allAgent`, { headers, params })
        .then((response) => {
          this.setState({ userroles: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
      handleDeleteRole = (role) => {
        Swal.fire({
          title: "Are you sure?",
          text: "This action cannot be undone.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            const obj = JSON.parse(localStorage.getItem("authUser"));
            const token = obj?.resultData?.bearerToken;
            axios
              .delete(`${API_URL}UserRole/${role.id}`, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              })
              .then((response) => {
                Swal.fire("Deleted!", "Delete successfully", "success");
                this.setState((prevState) => ({
                  userroles: prevState.userroles.filter((d) => d.id !== role.id),
                }));
              })
              .catch((error) => {
                Swal.fire("Error!", "An error occurred while deleting the document.", "error");
              });
          }
        });
      }

   handleUpdateSubmit = (value) => {
  const { id, userRoleId, userRoleTitle, agentId, isActive } = value;

  const payload = {
    id: Number(id),              
    userRoleId,                 
    userRoleTitle: userRoleTitle?.trim(), 
    agentId: Number(agentId),
    isActive: Boolean(isActive),
  };

  const token = JSON.parse(localStorage.getItem("authUser"))?.resultData?.bearerToken;
  if (!token) {
    toast.error("Unauthorized: No token found");
    return;
  }

  toast.loading("Please wait...");

  axios.put(`${API_URL}UserRole`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })
  .then(({ data }) => {
    toast.dismiss();

    if (data.success) {
      toast.success("Updated successfully!");
      this.fetchRoles();
    this.toggleEditRole();
    } else {
      toast.error(data?.validationErrors?.[0] || "Submission failed");
      console.warn("Submission failed:", data);
    }
  })
  .catch((error) => {
    toast.dismiss();
    console.error("Error submitting document:", error);
    //toast.error(error?.response?.data?.message || "Something went wrong!");
  });
};

  fecthRoleModule(roleId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      roleId: 4,
      forRoleId: roleId,
      agentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}UserRoleModulePermission/allbyroleidforroleid`, { headers, params })
      .then((response) => {

        this.setState({
          modules: response.data,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
   toggleAccordion = (index) => {
    this.setState({ openAccordion: this.state.openAccordion === index ? null : index });
  };
 renderDynamicAccordions = () => {
  const { modules } = this.state;
  if (!modules || modules.length === 0) return null;
  const groupedByType = _.groupBy(modules, "moduleTypeTitle");

  return Object.entries(groupedByType).map(([typeTitle, moduleItems], typeIdx) => {
  
    const headerPerms = _.uniq(
      moduleItems.flatMap(m => m.allowedPermissions?.split(",").map(p => p.trim()) || [])
    );

    return (
      <div className="accordion-item" key={typeIdx}>
       
      <div className="d-flex align-items-center w-100">
         <input
          type="checkbox"
          className="me-2"
          onChange={(e) => this.handleCheckAll(typeIdx, moduleItems, e.target.checked)}
          checked={this.state.checkedAccordions?.[typeIdx] || false}
       />
        <button
            className="accordion-button fw-medium"
            type="button"
            onClick={() => this.toggleAccordion(typeIdx)}
            style={{ cursor: "pointer" }}
          >
            {typeTitle}
          </button>
      </div>
        <Collapse isOpen={this.state.openAccordion === typeIdx} className="accordion-collapse">
          <div className="accordion-body">
            <div className="table-responsive">
              <table className="table align-middle table-nowrap mb-0">
                <thead>
                  <tr>
                    <th></th>
                    {headerPerms.map((perm) => (
                      <th key={perm} className="text-center">{perm}</th>
                    ))}
                  </tr>
                </thead>

              

                <tbody>
                {_.uniqBy(moduleItems, "moduleTitle").map((module) => {
                  const allowedPerms = module.allowedPermissions
                    ?.split(",")
                    .map((p) => p.trim()) || [];

                  const currentValues = this.formikRef.current?.values?.[module.moduleTitle] || [];
                  const isRowFullyChecked = allowedPerms.every((perm) => currentValues.includes(perm));

                  return (
                    <tr key={module.moduleId}>
                      

                      <td> <input
                          type="checkbox"
                          checked={isRowFullyChecked}
                          className="me-2"
                          onChange={(e) => {
                            const { setFieldValue } = this.formikRef.current;
                            setFieldValue(
                              module.moduleTitle,
                              e.target.checked ? allowedPerms : []
                            );
                          }}
                        /> {module.moduleTitle}</td>

                      {allowedPerms.map((perm) => {
                        const permObj = moduleItems.find(
                          (m) => m.moduleId === module.moduleId && m.permTypeTitle === perm
                        );
                        return (
                          <td key={perm} className="text-center">
                            <Field
                              type="checkbox"
                              name={module.moduleTitle}
                              value={perm}
                              defaultChecked={permObj?.isAllowed}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
              </table>
            </div>
          </div>
        </Collapse>
      </div>
    );
  });
};

handleCheckAll = (accordionIndex, moduleItems, isChecked) => {
  const formik = this.formikRef.current;
  if (!formik) return;

  const { setFieldValue } = formik;

  _.uniqBy(moduleItems, "moduleTitle").forEach((module) => {
    const allowedPerms = module.allowedPermissions?.split(",").map((p) => p.trim()) || [];

    if (isChecked) {
      setFieldValue(module.moduleTitle, allowedPerms); 
    } else {
      setFieldValue(module.moduleTitle, []); 
    }
  });

  // Update accordion-level toggle state (optional)
  this.setState((prev) => ({
    checkedAccordions: { ...prev.checkedAccordions, [accordionIndex]: isChecked }
  }));
};

render() {
    const { userroles, role, modules } = this.state;
  const initialValues = _.chain(modules)
  .groupBy('moduleTitle')
  .mapValues(list => list
    .filter(item => item.selectedIsAllowed === true)
    .map(item => item.permTypeTitle)
  )
  .value();
    return (
      <React.Fragment>
           <ToastContainer autoClose={2000} />
        <div className="page-content">

          <MetaTags>
            <title>Agent Profile | Realty Space</title>
          </MetaTags>
          <Container fluid>
          
       
           <Row className="">
            <Col xl="6">
             <Breadcrumbs
              title={this.props.t("Agent")}
              breadcrumbItem={this.props.t("Manage Role")}
            />
           
            </Col>
            <Col sm="6">
             <div className="pt-2 mt-2 d-flex justify-content-center justify-content-xl-end flex-wrap">
                              <RsAdNewV2 to="#" onClick={this.toggleManageRole} iconClass="bx bx-right-arrow-alt" className="text-purple">
                                  Add Role
                              </RsAdNewV2>

                              
              </div>
           
            </Col>
            </Row>
            <Row className="mt-4">
              <Col xl="3">
              <SettingSidebar />
              </Col>
              
              <Col xl="9">
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                   
                   

                  }}
                  validationSchema={Yup.object().shape({
                   
                   
                  })}

                  onSubmit={values => {
                  
                   
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
            

            
                <Card> 
                    <CardBody>
                    
					<div className="table-responsive">
          <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
              <thead className="">
							  <tr>
								<th>#</th>
								<th>Name</th>
								<th>Permission</th>
                <th>Action</th>
               
                
							  </tr>
							</thead>
                    <tbody>
                              {userroles?.map((role, i) => (
                                    <tr key={i}>
                                        <td>{i+1}</td>
                                        <td>{role.userRoleTitle}</td>
                                        <td><Link to="#" onClick={() => this.toggleSetPermission(role)}>Permission</Link></td>
                                        <td>
                                            {role.agentId > 0 &&(
                                                <>
                                            <ActionEdit onClick={()=> this.toggleEditRole(role)} />
                                            <ActionDelete onClick={()=> this.handleDeleteRole(role)} />
                                            </>
                                            )}
                                        </td>
                                    </tr>
                              ))}
                     
                     
                    </tbody>
						  </table>
						</div>
					</CardBody>
					</Card>

                
                


               

            

</Form>
)}
</Formik>


 
            
            </Col>
            
            </Row>
           
          </Container>
        </div>

             <Offcanvas
                        isOpen={this.state.isAddNew}
                        direction="end"
                        toggle={this.toggleManageRole}
                        style={{ width: 500 }}
                      >
                        <OffcanvasHeader toggle={this.toggleManageRole}>
                          New Role
                        </OffcanvasHeader>
                        <OffcanvasBody>
                           <Formik
                                enableReinitialize={true}
                                initialValues={{
                                
                                   userRoleTitle: "",
                                   agentId : localStorage.getItem('userId')

                                }}
                                validationSchema={Yup.object().shape({
                                       userRoleTitle: Yup.string().required("This Field in required"),
                                
                                })}

                                onSubmit={this.handleSubmit}
                                >
                                {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                    className="needs-validation"
                                    >
                                     <Row>
                                               <FormGroup className="mb-3">
                                                <Label htmlFor="userRoleTitle">
                                                {this.props.t("Role Title *")}
                                                </Label>
                                                <SafeField
                                                name="userRoleTitle"
                                                type="text"
                                                onChange={handleChange}
                                                className={
                                                    "form-control" +
                                                    (errors.userRoleTitle && touched.userRoleTitle
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                id="userRoleTitle"
                                                />
                                                <ErrorMessage
                                                name="userRoleTitle"
                                                component="div"
                                                className="invalid-feedback"
                                                />
                                            </FormGroup>

                                             <div><SaveButton>{this.props.t("Save")}</SaveButton>{ " " } <RsLink onClick={this.toggleManageRole}>Close</RsLink></div>
                                    </Row>           
                                    </Form>
                                )}
                                </Formik>
                        </OffcanvasBody>
                      </Offcanvas>


                          <Offcanvas
                        isOpen={this.state.isManage}
                        direction="end"
                        toggle={this.toggleEditRole}
                        style={{ width: 500 }}
                      >
                        <OffcanvasHeader toggle={this.toggleEditRole}>
                          Update Role
                        </OffcanvasHeader>
                        <OffcanvasBody>
                           <Formik
                                enableReinitialize={true}
                                initialValues={{
                                    id:role?.id,
                                    userRoleId:role?.userRoleId,
                                    userRoleTitle: role?.userRoleTitle,
                                    agentId : role?.agentId,
                                    isActive: role?.isActive

                                }}
                                validationSchema={Yup.object().shape({
                                       userRoleTitle: Yup.string().required("This Field in required"),
                                
                                })}

                                onSubmit={this.handleUpdateSubmit}
                                >
                                {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                    className="needs-validation"
                                    >
                                     <Row>
                                               <FormGroup className="mb-3">
                                                <Label htmlFor="userRoleTitle">
                                                {this.props.t("Role Title *")}
                                                </Label>
                                                <SafeField
                                                name="userRoleTitle"
                                                type="text"
                                                onChange={handleChange}
                                                className={
                                                    "form-control" +
                                                    (errors.userRoleTitle && touched.userRoleTitle
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                id="userRoleTitle"
                                                />
                                                <ErrorMessage
                                                name="userRoleTitle"
                                                component="div"
                                                className="invalid-feedback"
                                                />
                                            </FormGroup>

                                             <div><SaveButton>{this.props.t("Update")}</SaveButton>{ " " } <RsLink onClick={this.toggleEditRole}>Close</RsLink></div>
                                    </Row>           
                                    </Form>
                                )}
                                </Formik>
                        </OffcanvasBody>
                      </Offcanvas>



                          <Offcanvas
                        isOpen={this.state.isPermission}
                        direction="end"
                        toggle={this.toggleSetPermission}
                        style={{ width: 900 }}
                      >
                        <OffcanvasHeader toggle={this.toggleSetPermission}>
                          Set Permission
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Formik
                                    innerRef={this.formikRef} 
                                    enableReinitialize={true}
                                    initialValues={initialValues}
                                    validationSchema={Yup.object().shape({


                                    })}

                                    onSubmit={(values) => {
                                            const { modules, role } = this.state;

                                            const payload = {
                                              userRoleModulePermissions: modules.map((mod) => {
                                                const selectedPerms = values[mod.moduleTitle] || []; 
                                                const isAllowed = selectedPerms.includes(mod.permTypeTitle);
                                                
                                                return {
                                                  id: mod.selectedUserRoleUserRoleModulePermissionId || 0,
                                                  userRoleModulePermissionId: mod.userRoleModulePermissionId, 
                                                  userRoleModulePermissionTitle: mod.selecteduserRoleModulePermissionTitle,
                                                  userRoleId: role?.id, 
                                                  moduleId: mod.moduleId,
                                                  permissionId: mod.permissionId,
                                                  isAllowed
                                                };
                                              })
                                              
                                            };

                                            const token = JSON.parse(localStorage.getItem("authUser"))?.resultData?.bearerToken;
                                            if (!token) {
                                              toast.error("Unauthorized: No token found");
                                              return;
                                            }

                                            toast.loading("Please wait...");

                                            axios.post(`${API_URL}UserRoleModulePermission/bulkadd`, payload, {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                                "Content-Type": "application/json",
                                              },
                                            })
                                            .then(({ data }) => {
                                              toast.dismiss();

                                              if (data.success) {
                                                toast.success("Saved successfully!");
                                                this.fetchRoles();
                                                this.toggleSetPermission();
                                              } else {
                                                 toast.dismiss();
                                                 toast.success("Saved successfully!");
                                              
                                              }
                                            })
                                            .catch((error) => {
                                              toast.dismiss();
                                              //console.error("Error submitting document:", error);
                                              toast.success("Saved successfully!");
                                            });

                            
                                          }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >

                                                   <div className="accordion accordion-flush" id="userPermission">
                                                            {this.renderDynamicAccordions()}
                                                    </div>
                                            
                                            <div style={{marginTop:20}}></div>
                                            <SaveButton>Save</SaveButton>
                                        </Form>
                                    )}
                                </Formik>

                         
                        </OffcanvasBody>
                      </Offcanvas>
      </React.Fragment>
    )
  }
}
ManageRole.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
 

}
const mapStateToProps = () => (
  {
    
    

  })
const mapDispatchToProps = dispatch => ({
  

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ManageRole))
